import { render, staticRenderFns } from "./PasswordPair.vue?vue&type=template&id=3611038a&"
import script from "./PasswordPair.vue?vue&type=script&lang=js&"
export * from "./PasswordPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PasswordPair.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
